export const AssetTypes = [
  { key: "inventory", labelKey: "inventory" },
  { key: "medical_device", labelKey: "medical_device" },
  { key: "high_value", labelKey: "high_value" },
  { key: "chemical", labelKey: "chemical" },
  { key: "pharma", labelKey: "pharma" },
  { key: "cold_chain", labelKey: "cold_chain" },
  { key: "asset_tracking", labelKey: "asset_tracking" },
]
